/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Units_MetricInputs */

const en_us2_history_transfer_units_metric = /** @type {(inputs: History_Transfer_Units_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg and km`)
};

const pt_br2_history_transfer_units_metric = /** @type {(inputs: History_Transfer_Units_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg e km`)
};

const es_419_history_transfer_units_metric = /** @type {(inputs: History_Transfer_Units_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg y km`)
};

const pt_pt2_history_transfer_units_metric = /** @type {(inputs: History_Transfer_Units_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg e km`)
};

const fr_fr2_history_transfer_units_metric = /** @type {(inputs: History_Transfer_Units_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg et km`)
};

const de_de2_history_transfer_units_metric = /** @type {(inputs: History_Transfer_Units_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg und km`)
};

const it_it2_history_transfer_units_metric = /** @type {(inputs: History_Transfer_Units_MetricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg e km`)
};

/**
* | output |
* | --- |
* | "kg and km" |
*
* @param {History_Transfer_Units_MetricInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_units_metric = /** @type {((inputs?: History_Transfer_Units_MetricInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Units_MetricInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_units_metric(inputs)
	if (locale === "es-419") return es_419_history_transfer_units_metric(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_units_metric(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_units_metric(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_units_metric(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_units_metric(inputs)
	return en_us2_history_transfer_units_metric(inputs)
});
export { history_transfer_units_metric as "history-transfer.units_metric" }